module.exports = __webpack_public_path__ + "static/media/raspberrypi.218eab05.jpg";